import { render, staticRenderFns } from "./MaterialShipmentForm.vue?vue&type=template&id=48fff936&"
import script from "./MaterialShipmentForm.vue?vue&type=script&lang=js&"
export * from "./MaterialShipmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports